import { useLocation } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { shellHead } from "@/core/shellHead";

/**
 * Keeps the server-rendered head on the first route while its view is still loading. Views render later and
 * override it with their own SEO, and it stops applying once the visitor navigates away.
 */
export const ShellHeadFallback = () => {
    const { pathname, search } = useLocation();
    const isShellRoute = shellHead !== null && shellHead.location === pathname + search;

    const seo = useSEO({
        title: shellHead?.title ?? "",
        description: shellHead?.description,
        canonicalUrl: shellHead?.canonical,
        ogImage: shellHead?.ogImage,
    });

    return isShellRoute ? seo : null;
};
